<template>
  <div class="discovery-stats-chart">
    <div class="discovery-stats-chart__sources">
      <DiscoveryStatsChartSource
        v-for="option in sourceOptions"
        :key="option.value"
        :title="option.title"
        :is-active="activeSource === option.value"
        @click.native="activeSource = option.value"
      />
    </div>

    <div>
      <DiscoveryStatsChartLegend
        :title="$t('ADVERTISEMENT.DISCOVERY_ADS.YOUR_SOFTWARE_AVERAGE')"
        :color="seriesColors[0]"
        :is-active="chartsVisibility[0]"
        @click="handleClickLegend(0)"
      />
    </div>

    <BaseChart ref="baseChart" :options="options" />
  </div>
</template>

<script>
import BaseChart from '@@/common/stats/BaseChart';
import Color from '@/utils/color';
import DiscoveryStatsChartLegend from './DiscoveryStatsChartLegend';
import DiscoveryStatsChartSource from './DiscoveryStatsChartSource';

const SERIES_COUNT = 1;

export default {
  name: 'DiscoveryStatsChart',

  components: {
    BaseChart,
    DiscoveryStatsChartLegend,
    DiscoveryStatsChartSource,
  },

  props: {
    dates: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const chartsVisibility = [];
    for (let i = 0; i < SERIES_COUNT; i++) {
      chartsVisibility.push(true);
    }

    return {
      chartsVisibility,
      activeSource: 'M',
    };
  },

  computed: {
    seriesDates() {
      return Object.keys(this.dates);
    },

    seriesColors() {
      return Color.get(SERIES_COUNT).byStep(2, 6);
    },

    series() {
      return [
        {
          name: '',
          data: Object.values(this.dates).map(data => data[this.activeSource]),
        },
      ];
    },

    options() {
      return {
        chart: {
          height: '300',
        },
        xAxis: {
          categories: this.seriesDates,
        },
        colors: this.seriesColors,
        yAxis: [
          {
            labels: {
              style: {
                color: this.seriesColors[1],
              },
            },
            title: false,
          },
          {
            title: false,
            labels: {
              style: {
                color: this.seriesColors[0],
              },
            },
            opposite: true,
          },
        ],
        legend: false,
        title: false,
        series: this.series,
      };
    },

    sourceOptions() {
      return [
        {
          title: this.$t('ADVERTISEMENT.DISCOVERY_ADS.IMPRESSION'),
          value: 'M',
        },
        {
          title: this.$t('ADVERTISEMENT.DISCOVERY_ADS.VISIT'),
          value: 'V',
        },
        {
          title: this.$t('ADVERTISEMENT.DISCOVERY_ADS.DOWNLOAD'),
          value: 'D',
        },
        {
          title: this.$t('ADVERTISEMENT.DISCOVERY_ADS.INSTALL'),
          value: 'I',
        },
      ];
    },
  },

  watch: {
    chartsVisibility: {
      deep: true,
      handler() {
        const chart = this.$refs.baseChart.getChart();

        this.chartsVisibility.forEach((isVisible, index) => {
          if (isVisible) {
            chart.series[index].show();
            return;
          }
          chart.series[index].hide();
        });
      },
    },
  },

  methods: {
    handleClickLegend(index) {
      this.$set(this.chartsVisibility, index, !this.chartsVisibility[index]);
    },
  },
};
</script>

<style lang="scss">
.discovery-stats-chart {
  height: 100%;
  border: 1px solid $light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding * 1.5;
  background-color: #fff;

  &__sources {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: $global-margin * 2;
  }
}
</style>
